/**
 * Версия приложения для футера.
 * Источник: package.json (build-time).
 */
import packageJson from '../../package.json';

export const APP_VERSION = (packageJson?.version ?? '1.0.0').toString();
